<script setup lang="ts">
import { onMounted, ref } from 'vue';

const xx = ref('asds');
onMounted(() => {
  xx.value = '1';
});
</script>

<template>
  <div>
    <div>666asdaasd大萨达</div>
  </div>
</template>

<style scoped></style>
